/*!
* @nutui/nutui v3.3.6 Fri Mar 10 2023 14:47:18 GMT+0800 (中国标准时间)
* (c) 2022 @jdf2e.
* Released under the MIT License.
*/
import { createApp } from "vue";
import { j as isString, k as isFunction } from "./component.js";
const CreateComponent = (options, component) => {
  let elWarp = document.body;
  const teleport = options.teleport || "body";
  if (teleport != "body") {
    if (isString(teleport)) {
      elWarp = document.querySelector(teleport);
    } else {
      elWarp = options.teleport;
    }
  }
  const root = document.createElement("view");
  const name = component.name ? component.name + "-" : "";
  const id1 = options.id || new Date().getTime();
  root.id = name + id1;
  let Wrapper = {};
  if (isFunction(component.wrapper)) {
    Wrapper = component.wrapper(elWarp, root);
  } else {
    Wrapper = component.wrapper;
  }
  const instance = createApp(Wrapper, options);
  const componens = component.components;
  componens && componens.forEach((comp) => {
    instance.use(comp);
  });
  elWarp.appendChild(root);
  return {
    instance: instance.mount(root),
    unmount: () => {
      instance.unmount();
      elWarp.removeChild(root);
    }
  };
};
export { CreateComponent as C };
